<div class="logos-wrapper">
  <!-- ADA (current platform) -->
  <div [style.height]="'80px'">
    <img
      (click)="closePlatformPicker()"
      class="logo selected-platform"
      alt="anessa ada logo"
      src="/dbapi/logo?product=ADA&accountid={{getAccountID()}}" />
  </div>

  <!-- ADO -->
  <div [matTooltip]="adoExpired() ? ('PROJECT.HOME.PLATFORM_EXPIRATION' | anessaTranslation) : null">
    <div [style.height]="'80px'">
      <a (click)="gotoADO()"  class="platform-link" [class.unavailable-platform]="!canAccessADO() || adoExpired()">
        <img
          class="logo"
          alt="{{'HEADER.logo_alt' | anessaTranslation: trigger}}"
          src="/dbapi/logo?product=ADO&accountid={{getAccountID()}}" />
      </a>
    </div>
  </div>

  <!-- ADM -->
  <div [matTooltip]="admExpired() ? ('PROJECT.HOME.PLATFORM_EXPIRATION' | anessaTranslation) : null">
    <div [style.height]="canAccessADF() ? '80px' : ''">
      <a (click)="gotoADM()" class="platform-link"  [class.unavailable-platform]="!canAccessADM() || admExpired()">
        <img
          class="logo"
          alt="anessa adm logo"
          src="/dbapi/logo?product=ADM&accountid={{getAccountID()}}" />
      </a>
    </div>
  </div>

  <!-- ADF -->
  @if (canAccessADF()) {
    <div>
      <div>
        <a (click)="gotoADF()" class="platform-link">
          <img
          class="logo"
          alt="anessa adf logo"
          src="/dbapi/logo?product=ADF&accountid={{getAccountID()}}" />
        </a>
      </div>
    </div>
  }
</div>